import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

// Importer les pages CNAMGS
import PatientPage from "../pages/PatientPage";
import DoctorPage from "../pages/DoctorPage";
import PharmacistPage from "../pages/PharmacistPage";
import AdminPage from "../pages/AdminPage";
import MedicalRecord from "../components/Patient/MedicalRecord";
import ConsultationHistory from "../components/Patient/ConsultationHistory";


import PatientDashboard from "../components/Patient/PatientDashboard";
// Importer les pages existantes de votre template (ajustez les chemins selon votre structure)
// Si ces pages n'existent pas, commentez-les ou créez des composants temporaires
// import Dashboard from "../pages/Dashboard";
// import Profile from "../pages/Profile";
// import Settings from "../pages/Settings";

// Composant pour protéger les routes selon le rôle
const RoleBasedRoute = ({ children, allowedRoles }) => {
  const { user } = useAuth();
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  if (!allowedRoles.includes(user.role)) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

// Composants temporaires si les pages n'existent pas
const Dashboard = () => <div className="p-4"><h2>Dashboard</h2><p>Bienvenue sur votre tableau de bord</p></div>;
const Profile = () => <div className="p-4"><h2>Profil</h2><p>Gérez votre profil ici</p></div>;
const Settings = () => <div className="p-4"><h2>Paramètres</h2><p>Configurez vos préférences</p></div>;

const protectedRoutes = [
  // Routes existantes du template
  {
    path: "dashboard",
    element: <Dashboard />
  },
  
  {
    path: "profile",
    element: <Profile />
  },
  {
    path: "settings",
    element: <Settings />
  },




  {
    path: "patient/history",
    element: <ConsultationHistory />
  },

  {
    path: "patient/medical-record",
    element: <MedicalRecord />
  },

  {
    path: "patient/accueil",
    element: <PatientDashboard />
  },


  
  
  // Routes CNAMGS
  {
    path: "patient/*",
    element: (
      <RoleBasedRoute allowedRoles={['patient']}>
        <PatientPage />
      </RoleBasedRoute>
    )
  },
  {
    path: "doctor/*",
    element: (
      <RoleBasedRoute allowedRoles={['doctor']}>
        <DoctorPage />
      </RoleBasedRoute>
    )
  },
  {
    path: "pharmacist/*",
    element: (
      <RoleBasedRoute allowedRoles={['pharmacist']}>
        <PharmacistPage />
      </RoleBasedRoute>
    )
  },
  {
    path: "admin/*",
    element: (
      <RoleBasedRoute allowedRoles={['admin']}>
        <AdminPage />
      </RoleBasedRoute>
    )
  }
];

export default protectedRoutes;